import type { PSDTemplate } from "../../../../../models/MockupConfig/index";

export function getDefaultMockupPreviewUrl(
  template: PSDTemplate | null | undefined,
): string | undefined {
  return template?.preview_url || template?.psd_url || undefined;
}

export function getMockupEditorPreviewUrl(
  template: PSDTemplate | null | undefined,
  hasLogoSelected: boolean,
  resolvedBlankUrl: string | null | undefined,
): string | undefined {
  const defaultPreview = getDefaultMockupPreviewUrl(template);
  if (!hasLogoSelected) return defaultPreview;
  return resolvedBlankUrl || template?.blank_preview_url || defaultPreview;
}
